module.exports = __webpack_public_path__ + "static/media/YF60_4.d14253aa.jpg";